import useApiClient from 'hooks/use-api-client';
import { useMutation } from '@tanstack/react-query';

export const useDeleteCustomFlow = () => {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (id: string) => apiClient.customFlows.delete(id)
  });
};
